import { Component, Input } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { Recipient } from '../../../interfaces/recipient';
import { Donor } from '../../../interfaces/donor';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ParticipantService } from '../../../services/participant.service';
import { TimelineHistory } from '../../../interfaces/timeline';
import { TimelineService } from '../../../services/timeline.service';
import { ParticipantHistoryBoxComponent } from '../participant-history-box/participant-history-box.component';
import { PagetoolbarComponent } from '../../pagetoolbar/pagetoolbar.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AuthService } from '../../../auth/auth.service';
import { Permission } from '../../../interfaces/permission';
import { Participant } from '../../../interfaces/participant';
import { ParticipantDeleteDialogComponent } from '../../participant/participant-delete-dialog/participant-delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RequestPriorityComponent } from '../../approvals/request-priority/request-priority.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ParticipantEditComponent } from '../../participant/participant-edit/participant-edit.component';
@Component({
  selector: 'app-participant-history',
  imports: [MatIconModule, CommonModule, ParticipantHistoryBoxComponent, PagetoolbarComponent, PagetoolbarComponent, MatExpansionModule],
  templateUrl: './participant-history.component.html',
  styleUrl: './participant-history.component.css'
})
export class ParticipantHistoryComponent {
  constructor(
    private readonly route: ActivatedRoute,
    private router: Router,
    private participantService: ParticipantService,
    private readonly dialog: MatDialog,
    private timelineService: TimelineService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private readonly authService: AuthService
  ) {
    // Register your SVG icons here
    this.matIconRegistry.addSvgIcon('human-male', this.domSanitizer.bypassSecurityTrustResourceUrl('/human-male.svg'));

    this.matIconRegistry.addSvgIcon('human-female', this.domSanitizer.bypassSecurityTrustResourceUrl('/human-female.svg'));
  }

  canAddParticipant: boolean = false;
  canEditParticipant: boolean = false;
  canRemoveParticipant: boolean = false;

  participantId: string | null = null;
  recipient?: Recipient;
  donor?: Donor;
  timelineHistory?: TimelineHistory[];

  ngOnInit(): void {
    this.authService.getAllPermissions$().subscribe((permissions) => {
      this.canAddParticipant = permissions.includes(Permission.PARTICIPANTS_ADD_INCLUDING_ALTRUISTS);
      this.canEditParticipant = permissions.includes(Permission.PARTICIPANTS_EDIT);
      this.canRemoveParticipant = permissions.includes(Permission.PARTICIPANTS_EDIT);
    });
    this.route.paramMap.subscribe((params) => {
      this.participantId = params.get('id'); // Assign the 'id' parameter to the variable
    });

    this.route.url.subscribe((urlSegments) => {
      const path = urlSegments.map((segment) => segment.path).join('/');
      if (path.includes('donor') && this.participantId) {
        this.participantService.getDonor(this.participantId).subscribe((result) => {
          this.donor = result;
        });
      } else if (path.includes('recipient') && this.participantId) {
        this.participantService.getRecipient(this.participantId).subscribe((result) => {
          console.log(result);
          this.recipient = result;
        });
      }
    });
    if (this.participantId) {
      this.timelineService.getHistory(this.participantId).subscribe((result) => {
        this.timelineHistory = result;
        console.log(this.timelineHistory);
      });
    }
  }
}
